import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ShoppingBag, List, X, User } from '@phosphor-icons/react';
import { useCartStore } from '../../store';
import { motion, AnimatePresence } from 'framer-motion';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const itemCount = useCartStore((state) => state.getItemCount());
  
  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/shop', label: 'Shop' },
    { path: '/about', label: 'About' },
    { path: '/contact', label: 'Contact' },
    // { path: '/track-order', label: 'Track Order' },
  ];
  
  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-border-default">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Mobile Menu Button */}
          <button
            data-testid="mobile-menu-btn"
            className="lg:hidden p-2 text-secondary hover:text-primary transition-colors"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <List size={24} />}
          </button>
          
          {/* Desktop Nav Links - Left */}
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.slice(0, 2).map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-${link.label.toLowerCase()}`}
                className={`font-body text-sm uppercase tracking-widest transition-colors duration-200 ${
                  isActive(link.path) ? 'text-primary' : 'text-secondary hover:text-primary'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
          
          {/* Logo - Center */}
          <Link to="/" data-testid="logo" className="flex-shrink-0">
            <img 
              src="/logo.png" 
              alt="Luster Adorn" 
              className="h-12 md:h-14 w-auto"
            />
          </Link>
          
          {/* Desktop Nav Links - Right */}
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.slice(2).map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-${link.label.toLowerCase()}`}
                className={`font-body text-sm uppercase tracking-widest transition-colors duration-200 ${
                  isActive(link.path) ? 'text-primary' : 'text-secondary hover:text-primary'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
          
          {/* Right Actions */}
          <div className="flex items-center gap-4">
            {/* <Link
              to="/admin/login"
              data-testid="admin-link"
              className="hidden sm:block p-2 text-secondary hover:text-primary transition-colors"
              title="Admin"
            >
              <User size={22} weight="light" />
            </Link> */}
            <Link
              to="/cart"
              data-testid="cart-link"
              className="relative p-2 text-secondary hover:text-primary transition-colors"
            >
              <ShoppingBag size={22} weight="light" />
              {itemCount > 0 && (
                <span className="absolute -top-1 -right-1 bg-primary text-white text-xs w-5 h-5 rounded-full flex items-center justify-center font-body">
                  {itemCount}
                </span>
              )}
            </Link>
          </div>
        </div>
      </nav>
      
      {/* Mobile Menu */}
      <AnimatePresence>
        {isMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="lg:hidden bg-white border-t border-border-default"
          >
            <div className="px-4 py-6 space-y-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  data-testid={`mobile-nav-${link.label.toLowerCase()}`}
                  onClick={() => setIsMenuOpen(false)}
                  className={`block font-body text-sm uppercase tracking-widest py-2 transition-colors ${
                    isActive(link.path) ? 'text-primary' : 'text-secondary'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              {/* <Link
                to="/admin/login"
                onClick={() => setIsMenuOpen(false)}
                className="block font-body text-sm uppercase tracking-widest py-2 text-secondary"
              >
                Admin Login
              </Link> */}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Navbar;
